import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=1e725fb9&scoped=true&"
import script from "./AccordionItem.vue?vue&type=script&lang=ts&"
export * from "./AccordionItem.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionItem.vue?vue&type=style&index=0&id=1e725fb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e725fb9",
  null
  
)

export default component.exports